import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { postShareFreightWithTrucker } from 'services/shareFreight';

export const useShareFreightQuery = (
  encodedFreightId: string,
  truckerUuid: string,
  options?: UseMutationOptions<void, Error>
) =>
  useMutation<void, Error>({
    mutationKey: ['shareFreight'],
    mutationFn: () => postShareFreightWithTrucker({ encodedFreightId, truckersUuid: [truckerUuid] }),
    ...options,
  });
